import axios from "../../../axios";
import { addNotification } from "../../../Utilities/notifications";

export const createOrg = async (payload,user) => {
    try {        
        let req = {
            "display_name": payload.display_name,
            "contact_email":  payload.contact_email?payload.contact_email:null,
            "description":payload.description?payload.description:"",
            "url":payload.url?payload.url:"",
            "location":payload.location?payload.location:"",
            "billing_email":payload.billing_email?payload.billing_email:null,
            "profile_pic":payload.profile_pic?payload.profile_pic:null
        }
        let { status } = await axios.post(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/organization`, req);
        return status
    } catch (err) {
        console.log("error while creating organization", err.message);
        addNotification({
          title: "Techforce.ai",
          message: "Please write to Customer support for futher assistance...",
          type: "danger"
        });
    }
}